/**
 * HMC Events - Invitation Tracking Page
 *
 * Displays invitation tracking data filtered for HMC events.
 * Uses the shared InvitationTrackingTable component pre-filtered to event_type='hmc'.
 *
 * Route: /app/hmc-events/invitation-tracking
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MailCheck } from 'lucide-react';
import { InvitationTrackingTable } from '@shared/components/InvitationTrackingTable';

export default function HMCInvitationTrackingPage() {
  return (
    <div className="h-full flex flex-col bg-dark-bg overflow-hidden">
      {/* Page header */}
      <div className="px-4 py-4 border-b border-dark-border/25 flex-shrink-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Link
              to="/app/hmc-events"
              className="text-dark-muted hover:text-dark-text transition-colors p-1 rounded-lg hover:bg-dark-surface/40"
              aria-label="Back to HMC Events"
            >
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-lg bg-brand-500/20 text-brand-500 flex items-center justify-center">
                <MailCheck className="w-5 h-5" />
              </div>
              <div>
                <h1 className="text-lg font-semibold text-dark-text">HMC Events - Invitation Tracking</h1>
                <p className="text-xs text-dark-muted">Track and manage HMC event invitations</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table content */}
      <div className="flex-1 overflow-auto p-4">
        <InvitationTrackingTable eventType="hmc" />
      </div>
    </div>
  );
}
